import React from 'react';
import { Message } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/collections/message.less';

export default Message;
